import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { IDataQualityAction } from '~src/spacesPlatform/models/actionNames';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { Messages } from '../../../codegen/Localize';
import { setSensitiveLabelAction } from '../../actions/labels/SetSensitiveLabelAction';
import { selectCatalogingOnSiteEnabled } from '../../selectors/CatalogSelectors';

export const SetSensitiveLabelEntityAction: IEntityAction<IContentInfo, IDataQualityAction> = {
    name: EntityActionNames.SetSensitiveDataLabel,
    translateName: Messages.editSensitivityAction,
    isVisible: (items, state) => selectCatalogingOnSiteEnabled(state),
    isClickable: (availableActions: IDataQualityAction) => !!(availableActions && availableActions.updateRemoveDataQuality),
    createReduxAction: (items) => {
        if (!items || items.length === 0 || items.length > 1) {
          throw new Error(Messages.setSensitiveDataLabelError());
        }
        return setSensitiveLabelAction(items[0]);
    }

};
